// ═══════════════════════════════════════════════════════════════════════════════
// Today's calendar date (YYYY-MM-DD) in a given or fallback IANA time zone
// ═══════════════════════════════════════════════════════════════════════════════

/** User setting first, then browser IANA zone, then Hong Kong. */
export const resolveDisplayTimeZone = (userTimezone?: string | null): string => {
  if (typeof userTimezone === 'string' && userTimezone.trim() !== '') {
    return userTimezone.trim();
  }
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Hong_Kong';
};

export const getTodayYmdInTimeZone = (timeZone: string): string => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const year = parts.find((p) => p.type === 'year')?.value ?? '';
  const month = parts.find((p) => p.type === 'month')?.value ?? '';
  const day = parts.find((p) => p.type === 'day')?.value ?? '';
  return `${year}-${month}-${day}`;
};

export const getHelperTodayYmd = (userTimezone?: string | null): string => {
  return getTodayYmdInTimeZone(resolveDisplayTimeZone(userTimezone));
};

/** First calendar day of the previous month in the given IANA time zone (YYYY-MM-DD). */
export const getFirstDayOfPreviousMonthYmdInTimezone = (timeZone: string): string => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const y = Number(parts.find((part) => part.type === 'year')?.value ?? '0');
  const m = Number(parts.find((part) => part.type === 'month')?.value ?? '1');
  const prevYear = m === 1 ? y - 1 : y;
  const prevMonth = m === 1 ? 12 : m - 1;
  return `${prevYear}-${String(prevMonth).padStart(2, '0')}-01`;
};
